// apiAdmin.js
import axios from "axios";
import { SplashApi } from "../constants/API";
import { toast } from "react-toastify";
import { getUserToken } from "../constants/EncryptedLocalStorage";

// 🔐 Local cache to avoid calling getUserToken() multiple times
let cachedToken = null;
let tokenLoading = null; // Promise lock

// 🔄 Universal Token Loader (safe + avoids null timing)
const loadToken = async () => {
  try {
    // Already cached
    if (cachedToken) return cachedToken;

    // A request is already fetching the token → wait for it
    if (tokenLoading) return tokenLoading;

    // First time: load token & store promise
    tokenLoading = getUserToken().then((token) => {
      cachedToken = token;
      return token;
    });

    return await tokenLoading;
  } catch (error) {
    console.error("Token load failed:", error);
    return null;
  } finally {
    tokenLoading = null;
  }
};
export const api = axios.create({
    baseURL:'https://medicalradar.es/',
});
// 🌐 Axios instance
export const apiAdmin = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});
axios.interceptors.request.use(
  async (config) => {
    try {
      const token = await getUserToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (err) {
      console.error("Error attaching token:", err);
    }
    return config;
  },
  (error) => Promise.reject(error)
);
// 🚀 Request Interceptor (runs before every API call)
apiAdmin.interceptors.request.use(
  async (config) => {
    try {
      const token = await loadToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (err) {
      console.error("Error attaching token:", err);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ❗ Response Interceptor — handles global 401
apiAdmin.interceptors.response.use(
  (response) => {
    if (
      response?.data?.action === "Unauthenticated request" ||
      response?.data?.error === "Unauthenticated."
    ) {
      toast.error("Session expired. Please log in again.");

      setTimeout(() => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/";
      }, 500);
    }

    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();

      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);
export const clearToken = () => {
  cachedToken = null;
  tokenLoading = null;
};

// 🌟 API Functions (NO TOKEN HEADER REQUIRED ANYMORE)
export const getSplashData = () => {
  return apiAdmin.get(SplashApi); // interceptor auto-adds token
};
